import React from 'react';
import Box from '@mui/material/Box';
import {SvgProps} from '../../helpers/type';

const Plus = ({className, sx}: SvgProps): JSX.Element => {
    return (
        <Box
            component="svg"
            viewBox="0 0 17 17"
            width={17}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            sx={sx}
        >
            <path
                opacity="0.9"
                d="M0.249023 7.16124H16.8516V9.35755H0.249023V7.16124ZM9.6671 0.0883789V16.691H7.43357V0.0883789H9.6671Z"
                fill="#174943"
            />
        </Box>
    );
};

export default Plus;
